export default function SchematicSectionDirective() {
  return {
    template: require('./schematic-section.html'),
    scope: {
      customerId: '=',
      assessmentId: '=',
      title:'@',
      sectionId:'=',
      sectionName:'@',
      schematicItems: '=',
      tooltipAppendToSelector: '@',
    },
    controller: 'SchematicSectionController',
    controllerAs: 'schematicSectionVM',
    bindToController: true,
    replace: true,
  };
}
